import { ricsAndCompanyBranchLabels } from '../constants/branch-labels';
import { defineTreeFilter } from '../engine/descriptor';
import type { FilterDefinition } from '../engine/types';
import { FilterId, FilterType, type TreeFilter } from '../types/filters';

export const companyDescriptor = defineTreeFilter({
  definition: {
    id: FilterId.COMPANY,
    name: 'Company',
    selectionListIds: ['rics_k10', 'rics_k400', 'company'],
    selections: [],
    branches: ricsAndCompanyBranchLabels,
    type: FilterType.TREE,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_COMPANY },
});

export const companyDefinition: FilterDefinition<TreeFilter> =
  companyDescriptor.definition;
